'use strict';

var React = require('react');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var CardContent$2 = require('../../node_modules/@material-ui/core/esm/CardContent/CardContent.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles() {
  return {
    padding: {
      padding: 16,
      '&:last-child': {
        paddingBottom: 16
      }
    }
  };
};

var CardContent = function CardContent(_ref) {
  var classes = _ref.classes,
      children = _ref.children;
  return React__default["default"].createElement(CardContent$2["default"], {
    className: classes.padding
  }, children);
};

var CardContent$1 = withStyles(styles)(CardContent);

module.exports = CardContent$1;
